export default "__VITE_ASSET__C01JKH0A__"